import http from './http'

export function getConnectorDownloads() {
  return http.get('/connector/downloads')
}
